import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=3d31f94b&scoped=true&"
import script from "./PartnerInfo.vue?vue&type=script&lang=ts&"
export * from "./PartnerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=3d31f94b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d31f94b",
  null
  
)

export default component.exports